import { UIIcon } from '../../../config/icons';
import { FPageBlock, FPageCardItem } from '../../mdl/f-page-block';
import { UIInputAdapter } from '../../ui/component/adapter';
import { UILabeled } from '../../ui/component/labeled';
import { hLine } from '../../ui/component/line';
import { UIList } from '../../ui/component/list';
import { $el } from '../../ui/elements';
import { UIPoint } from '../../ui/types';
import { UIView, UIViewSpec } from '../../ui/view';
import { YEventHandlers, YStateEvent, YInputEvent, YValueEvent } from '../../y/events';
import { YInput, YForm, $form } from '../../y/form';
import { EDBlock, EDBlockSpec } from '../block';
import { EDObject, EDBlockContainer, EDButtonSpec } from '../editor';
import { EDSymbolInput } from '../image';
import { EDI18NInput } from '../input';
import { $page_values } from './values';

class EditorCardItem extends UIView implements EDObject, YInput<FPageCardItem> {
    $handlers: YEventHandlers<YStateEvent & YInputEvent & YValueEvent<FPageCardItem>>;

    doRemove?: () => void;
    properties: UIViewSpec;
    parent: EDBlock;
    private _form: YForm<FPageCardItem>;
    okay = true;
    dirty = false;
    disabled = false;
    name = 'Item';

    constructor(block: EDBlock) {
        const sym = $el.DIV('sym');
        const title = new EDI18NInput({ multiline: true, styleable: true, classes: 'r-title', formats: $page_values.default_formats, default_format: 'text' });
        const text = new EDI18NInput({ multiline: true, styleable: true, classes: 'r-text', formats: $page_values.default_formats, default_format: 'text' });
        const symbol = new EDSymbolInput(sym);

        super('div', ['ed-object', 'o-card', 'm-soft-shadow'], [
            $el.DIV('r-symbol m-40', sym),
            title,
            hLine(),
            text
        ]);

        this.ui_elem.ed_object = this;
        this.parent = block;
        this._form = $form({ title, text, symbol });

        this.root.addEventListener('click', e => {
            block.editor.selectObject(this);
            e.stopPropagation();
        });

        this.properties = $el.DIV('l-form', [
            new UILabeled(symbol, { above: 'Symbol' }),
        ]);
    }

    get value() {
        return this._form.value;
    }

    set value(v: FPageCardItem) {
        this._form.value = v;
    }
}

export const ed_page_cards_block: EDBlockSpec<FPageBlock> = {
    key: 'cards',
    editor_block: class extends EDBlock {
        private _items: UIInputAdapter<FPageCardItem, EditorCardItem>;

        constructor(container: EDBlockContainer) {
            const items = new UIInputAdapter<FPageCardItem, EditorCardItem>((_, entry) => {
                const item: EditorCardItem = new EditorCardItem(this)
                item.doRemove = () => { items.remove(entry); };
                return { view: item, input: item };
            });

            const list = new UIList<UIViewSpec>(items, { classes: ['blk-cards', 'w-block', 'b', 'b-content'] });

            super($form({ items }), container, 'Cards', undefined, list.ui_elem);

            this._items = items;
        }

        override getButtons(): EDButtonSpec[] {
            const rect = this.ui_elem.getBoundingClientRect();
            const views = this._items.views;
            const pos: UIPoint = [rect.left + rect.width / 2, rect.top + rect.height / 2];

            if(views.length) {
                const last_item = views[views.length - 1];
                const bounding = last_item.ui_elem.getBoundingClientRect();
                pos[0] = bounding.right + 20;
                pos[1] = bounding.top + bounding.height / 2;
            }

            return [{
                icon: UIIcon.PLUS,
                classes: 'm-round',
                action: () => {
                    this._items.push({ title: {}, text: {} });
                },
                position: pos,
                tooltip: 'Add card'
            }, ...this.parent.getChildButtons(this)];
        }

        get children() {
            return this._items.views;
        }
    },
};
